import React from 'react';
import ReactDOM from 'react-dom';
import { WithContext as ReactTags } from 'react-tag-input';
import '../TextBoxMultiCarFilter/css/TextBoxMultiCarFilter.css';
import { getMainCookie,checkStatus } from '../../../../util/util'

const KeyCodes = {
    comma: 188,
    enter: 13
};

const delimiters = [KeyCodes.comma, KeyCodes.enter];

var user_id = "";
var user_name = "";
var token = "";
class TextBoxMultiCarFilter extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            tags: [

            ],
            suggestions: [
                // {
                //     id: "5",
                //     device_id:"5",
                //     device_no: "4ab-1111"
                // }, {
                //     id: "2",
                //     device_id:"2",
                //     device_no: "4ab-2222"
                // }, {
                //     id: "3",
                //     device_id:"3",
                //     device_no: "4กพ-2240"
                // }, {
                //     id: "4",
                //     device_id:"5",
                //     "device_no": "5กก-1287"
                // }

            ]
        };
        this.handleDelete = this.handleDelete.bind(this);
        this.handleAddition = this.handleAddition.bind(this);
        //this.handleDrag = this.handleDrag.bind(this);
    }
    componentDidMount(){
        let main =getMainCookie();
        user_id=main.user_id;
        user_name=main.login_name;
        token =main.token;
        this.setState({
            tags: this.props.selecttags
        },()=> this.handleTextChange(""));
        
    }
    componentWillUnmount(){
        this.setState({
            tags: [],
            suggestions:[]
        });
    }

    handleDelete(i) {
        const { tags } = this.state;
        this.setState({
            suggestions:[],
            tags: tags.filter((tag, index) => index !== i),
        },()=>{this.handleTextChange("");this.props.onChange(this.state.tags)});
      
    }

    handleAddition(tag) {
        console.log("handleAddition",tag)
        this.handleTextChange("");
        if (!this.props.limitSelect || (this.props.limitSelect && this.state.tags.length < this.props.limitSelect) ) {
            // this.setState({
            //     suggestions:[]
            // })
            if(tag.imei){
                console.log("zzzzzzzzzzzzz1")
                this.setState({ tags: [...this.state.tags, tag] },()=>{this.props.onChange(this.state.tags)});
                
            }else{
                console.log("zzzz2")
                let currentComponent = this;
                fetch("http://203.150.199.244/api/admin/getActiveDeviceUserRelated/1000", {
                    method: 'post',
                    headers: {
                        "Content-Type": "application/json; charset=utf-8",
                        "token":token
                        },
                    body: JSON.stringify(
                        {
                            "filter":tag.id
                        }
                    )
                }).then(function(response) {
                    return checkStatus(response);
                }).then(function(data) {
                    if(data.RESULT_STATUS==="000"){
                        console.log("zzzz3",data)
                        currentComponent.setState({ tags: [...currentComponent.state.tags, data.RESULT_DATA[0]] },()=>{console.log("zzzz4",currentComponent.state.tags);currentComponent.props.onChange(currentComponent.state.tags)});
                    }else{
                        currentComponent.setState({ tags: [...currentComponent.state.tags] },()=>{currentComponent.props.onChange(currentComponent.state.tags)});
                    }
                    // currentComponent.props.onChange(currentComponent.state.tags);    
                });
            }
            
            
        }

    }
    handleTextChange(e){
        let currentComponent = this;
        fetch("http://203.150.199.244/api/admin/getActiveDeviceUserRelated/1000", {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",

                // "user_id":user_id,
                // "user_name":user_name,
                "token":token
                },
            body: JSON.stringify(
                {
                    "filter":e
                }
            )
        }).then(function(response) {
            return checkStatus(response);
        }).then(function(data) {
            console.log('handleTextChange', data);
            if(data.RESULT_STATUS==="000"){
                currentComponent.setState({
                    suggestions:data.RESULT_DATA
                })
            }else{
                currentComponent.setState({
                    suggestions:[]
                })
            }
            
            
        });
    }

    handleFilterSuggestions (textInputValue, possibleSuggestionsArray) {
        return possibleSuggestionsArray
        // return possibleSuggestionsArray.filter((suggestion)=> {
        //     if(suggestion.device_no.toLowerCase().indexOf(textInputValue.toLowerCase())>-1)
        //     return suggestion;
        // })
    }

    // handleInputBlur(value){
    //     console.log('handleInputBlur',value);
    // }

    handleDrag(tag, currPos, newPos) {
        // const tags = [...this.state.tags];
        // const newTags = tags.slice();

        // newTags.splice(currPos, 1);
        // newTags.splice(newPos, 0, tag);

        // // re-render
        // this.setState({ tags: newTags });
        // this.props.onChange( this.state.tags);
    }

    render() {
        const { tags, suggestions } = this.state;
        
        return (
            <div style={{display:"inline-block"}}>
                <ReactTags tags={tags}
                    suggestions={suggestions}
                    handleDelete={this.handleDelete}
                    handleAddition={this.handleAddition}
                    // handleDrag={this.handleDrag}
                    delimiters={delimiters}
                    labelField={'device_no'}
                    placeholder =''
                    handleInputChange={this.handleTextChange.bind(this)}
                    handleFilterSuggestions={this.handleFilterSuggestions.bind(this)}
                    minQueryLength={0} 
                    // autocomplete = {true}
                    autofocus={false}
                    
                    // allowAdditionFromPaste
                    //handleInputBlur={this.handleInputBlur.bind(this)}
                    //allowDeleteFromEmptyInput={false}
                    />
            </div>
        )
    }
};

TextBoxMultiCarFilter.defaultProps = {
    selecttags: []
};
export default TextBoxMultiCarFilter;


// WEBPACK FOOTER //
// ./src/app/view/components/UserControl/TextBoxMultiCarFilter/TextBoxMultiCarFilter.js